// Add commas to the number (1000000 => 1,000,000)
export const numberWithCommas = (x: number | string): string | number => {
  if(x === null) return x;
  return x.toLocaleString(undefined, { maximumFractionDigits: 0 });
};

export const numberFormattedWithCurrency = (
  currency: string,
  num: number | string | undefined
): string => {
  return `${currency}${(num || num === 0) && num != null ? numberWithCommas(num) : "-"}`;
};

export const formattedPercentage = (percent: number) => {
  return `${percent.toLocaleString()}%`;
};